import { useCallback } from 'react';

export const useCopy = () => {
  const onCopyToClipboard = useCallback(({ text, message, error }) => {
    navigator.clipboard
      ? navigator.clipboard
          .writeText(text)
          .then(() => alert(message))
          .catch(() => {
            alert(error);
          })
      : alert(error);
  }, []);

  return { onCopyToClipboard };
};
